import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { ModelCompanyForm } from "models/companies/CompanyForm";
import {
  useNiceModalLocker,
  NiceModalComponent,
} from "components/context/NiceModalProvider";

export default NiceModal.create(({ id, ...props }) => {
  const modal = useModal();
  const { setLocked, closeFormIfNotLocked } = useNiceModalLocker(modal);

  return (
    <NiceModalComponent open={modal.visible} onClose={closeFormIfNotLocked}>
      <ModelCompanyForm
        objectId={id}
        setIsDirty={setLocked}
        onCreated={modal.hide}
        onCancel={modal.hide}
        {...props}
      />
    </NiceModalComponent>
  );
});
